import React from "react";

const GVAccordionPlus: React.FC = props => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_43256_18294)">
                <path d="M15 7.44999H8.57505V0.999988C8.57505 0.699988 8.32505 0.424988 8.00005 0.424988C7.70005 0.424988 7.42505 0.674988 7.42505 0.999988V7.44999H1.00005C0.700049 7.44999 0.425049 7.69999 0.425049 8.02499C0.425049 8.32499 0.675049 8.59999 1.00005 8.59999H7.45005V15C7.45005 15.3 7.70005 15.575 8.02505 15.575C8.32505 15.575 8.60005 15.325 8.60005 15V8.57499H15C15.3 8.57499 15.575 8.32499 15.575 7.99999C15.575 7.69999 15.3 7.44999 15 7.44999Z" fill="#111928"/>
            </g>
            <defs>
                <clipPath id="clip0_43256_18294">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(GVAccordionPlus);